import ControlTabs from '../../utilities/ControlTabs'

export const ctsView = new ControlTabs()
